export default {
      id: "social-youtube-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#social-youtube-usage",
      toString: function () {
        return this.url;
      }
    }